import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeNoValue extends TraitRegistryItem {
    constructor(init = {}) {
        super(init);
        Object.assign(this, init);
    }
}
